import { useEffect, useState } from 'react'
import { Stack } from '../../Components/Stack'
import TBDateRangePicker, {
  StartEndDatesStrings,
} from '../../Components/Commons/Dates/TBDateRangePicker.react'
import SingleTableLoader from '../../Components/Commons/Loaders/SingleTableLoader.react'
import { Heading1, Heading3 } from '../../Components/Headings'
import { Page } from '../../Components/Page'
import {
  Text,
  ErrorMessage,
  GenerateButton,
  SmallText,
} from '../../Components/Reports/Styles/Elements.styles'
import useFetchTaxForms from '../../Utilities/API/taxes/fetchTaxForms'
import Table from '../Reports/Table'
import { Container } from '../Reports/Elements'
import { Label } from '../Reports/GenerateReportForm/Elements'

const TaxesPage = () => {
  const [
    [reportsStatus, generationStatus],
    [reportsError, generationError],
    generateReport,
    fetchReports,
    gainLossReports,
  ] = useFetchTaxForms()

  useEffect(() => {
    fetchReports()
  }, [fetchReports])

  const [dates, setDates] = useState({
    startDate: '2021-01-01T00:00:00Z',
    endDate: '2021-12-31T00:00:00Z',
  })

  const handleDateChange = (dates: StartEndDatesStrings) =>
    setDates({
      startDate: dates.startDate.replace(/\.[0-9]{3}/, ''),
      endDate: dates.endDate.replace(/\.[0-9]{3}/, ''),
    })

  return (
    <Page>
      <Heading1>Taxes</Heading1>
      <Container>
        <Stack gapSize="3.0rem">
          <Heading3>Realized Gain / Loss</Heading3>
          <Text>To generate a new form select dates and click generate</Text>
          <Label>
            Date Range
            <TBDateRangePicker
              isCustomDate
              filter={dates}
              setDateFilter={handleDateChange}
              readOnly={true}
              utc
            />
          </Label>
          <Stack>
            <GenerateButton
              disabled={generationStatus === 'LOADING'}
              onClick={() =>
                generateReport({
                  reportLabel: 'GainLossReport',
                  reportName: 'GainLossReport',
                  ...dates,
                })
              }
            >
              {generationStatus === 'LOADING' ? 'Generating...' : 'Generate'}
            </GenerateButton>
            <SmallText>
              *Forms may take up to twenty minutes to generate
            </SmallText>
            {generationError && (
              <ErrorMessage>{generationError.message}</ErrorMessage>
            )}
            {reportsError && (
              <ErrorMessage>{reportsError.message}</ErrorMessage>
            )}
          </Stack>
        </Stack>
        {reportsStatus === 'LOADING' ? (
          <SingleTableLoader />
        ) : (
          <Table reports={gainLossReports ?? []} error={!!reportsError} />
        )}
      </Container>
    </Page>
  )
}

export default TaxesPage
